import { render } from "./ParoleForm.vue?vue&type=template&id=29fe1565&scoped=true"
import script from "./ParoleForm.vue?vue&type=script&lang=js"
export * from "./ParoleForm.vue?vue&type=script&lang=js"

import "./ParoleForm.vue?vue&type=style&index=0&id=29fe1565&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fe1565"]])

export default __exports__